export default __webpack_public_path__ + "static/media/Selected_Snooze.c62534ba.svg";